import React from "react";
import ChatPage from "src/views/ChatPage/ChatPage";
function App() {
  return (
    <div className="">
      <ChatPage />
    </div>
  );
}

export default App;
